import { combineReducers } from "redux";
import layerReducer from "./LayerReducer";
import sourceReducer from "./SourceReducer";
import layerTreeReducer from "./LayerTreeReducer";
import mapReducer from "./MapReducer";
import RegisteredLayerTreeReducer from "./RegisteredLayerTreeReducer";
import resultsPanelReducer from "./ResultsPanelReducer";
import appReducer from "./AppReducer";
import searchReducer from "./SearchReducer";
import cqlFilterReducer from "./CQLFilterReducer";
import sldEditorReducer from "./SLDEditorReducer";
import timeDimensionReducer from "./TimeDimensionReducer";
import swipeReducer from "./SwipeReducer";
import editReducer from "./EditReducer";
import searchCSWReducer from "./SearchCSWReducer";
import formsReducer from "./FormsReducer";

const rootReducer = combineReducers({
  layers: layerReducer,
  layerTree: layerTreeReducer,
  sources: sourceReducer,
  map: mapReducer,
  results: resultsPanelReducer,
  app: appReducer,
  search: searchReducer,
  registeredLayerTree: RegisteredLayerTreeReducer,
  sldEditor: sldEditorReducer,
  cqlFilter: cqlFilterReducer,
  timeDimension: timeDimensionReducer,
  swipe: swipeReducer,
  edit: editReducer,
  searchCSW: searchCSWReducer,
  forms: formsReducer,
});

export default rootReducer;
